import React from 'react';
import { Clock as ClockIcon, Moon, Sun } from 'lucide-react';

interface ClockProps {
    gameTime: number;
    className?: string;
}

export const Clock: React.FC<ClockProps> = ({ gameTime, className = '' }) => {
  const date = new Date(gameTime);
  const startRef = new Date("2024-01-01T08:00:00").getTime();
  
  // Calculate day number relative to start
  const dayNumber = Math.floor((gameTime - startRef) / (24 * 60 * 60 * 1000)) + 1;
  const hour = date.getHours();
  const isNight = hour >= 19 || hour < 6;

  return (
    <div className={`flex items-center space-x-3 font-mono text-sm border px-3 py-1 rounded shadow-sm transition-colors ${isNight ? 'border-indigo-900 bg-indigo-950/50 text-indigo-300' : 'border-noir-700 bg-noir-800 text-noir-accent'} ${className}`}>
      {isNight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      <span className="font-bold border-r border-current pr-2 mr-2">DIA {dayNumber}</span>
      <span>
        {date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
      </span>
    </div>
  );
};